import { render, staticRenderFns } from "./paidDetails.vue?vue&type=template&id=2d09d625&scoped=true&"
import script from "./paidDetails.vue?vue&type=script&lang=js&"
export * from "./paidDetails.vue?vue&type=script&lang=js&"
import style0 from "./paidDetails.vue?vue&type=style&index=0&id=2d09d625&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d09d625",
  null
  
)

export default component.exports